import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useStateSelector } from '../store/selectors';
import { addNotificationFlagToDelete } from '../slices/notification-flags/notification-flags.slice';

export const isFlagUnderPrefix = (eventCode: string, prefix: string) => {
    const lowerEventCode = eventCode.toLowerCase();
    const lowerPrefix = prefix.toLowerCase();
    return (
        lowerEventCode === lowerPrefix ||
        lowerEventCode.startsWith(`${lowerPrefix}.`)
    );
};

export const useClearNotificationFlagsOnLeave = (
    shouldClear: (eventCode: string) => boolean,
    placeKey: string | number
) => {
    const dispatch = useDispatch() as any;
    const notificationFlags = useStateSelector(
        (state) => state.notificationFlags.flags
    );
    const notificationFlagsRef = useRef(notificationFlags);
    notificationFlagsRef.current = notificationFlags;

    const clearFlags = (predicate: (eventCode: string) => boolean) => {
        notificationFlagsRef.current
            ?.filter((flag) => predicate(flag.eventCode))
            .forEach((flag) =>
                dispatch(
                    addNotificationFlagToDelete({
                        ...flag,
                        refreshAfterRemoval: true,
                    })
                )
            );
    };

    useEffect(() => {
        return () => {
            clearFlags(shouldClear);
        };
    }, [placeKey]);

    return clearFlags;
};
